import React, { useContext, useRef, useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Typography,
  useTheme,
  Card,
  CardContent,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Chip,
  TablePagination,
} from "@mui/material";

import { Outlet, useNavigate } from "react-router-dom";

import { ColorModeContext } from "../App";
import DashboardHeader from "../Dashboard/DashboardHeader";

import { useMediaQuery } from "@mui/material";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { entity_id } from "../Utils/Const";
import api from "../Utils/Api";
import { baseapi } from "../Environmentalurl";
import RefreshIcon from "@mui/icons-material/Refresh";
import { CircularProgress } from "@mui/material";

// SERVICES
const services = [
  { title: "DTH", icon: "📺", path: "/dashboard/bbps/DTH" },
  {
    title: "Mobile Postpaid",
    icon: "📶",
    path: "/dashboard/bbps/Postpaid",
  },
  { title: "Gas", icon: "🔥", path: "/dashboard/bbps/gas" },
  { title: "LPG Gas", icon: "🛢️", path: "/dashboard/bbps/LPGGas" },
  {
    title: "Landline Postpaid",
    icon: "📞",
    path: "/dashboard/bbps/LandlinePostpaid",
  },
  {
    title: "Broadband Postpaid",
    icon: "🌐",
    path: "/dashboard/bbps/Internet",
  },
  { title: "Cable TV", icon: "📡", path: "/dashboard/bbps/CableTV" },
  { title: "FasTag", icon: "🚗", path: "/dashboard/bbps/fastag" },

  {
    title: "Health Insurance",
    icon: "🏥",
    path: "/dashboard/bbps/HealthInsurance",
  },

  {
    title: "Housing Society",
    icon: "🏘️",
    path: "/dashboard/bbps/HousingSociety",
  },

  {
    title: "Insurance",
    icon: "🛡️",
    path: "/dashboard/bbps/insurance",
  },

  {
    title: "Life Insurance",
    icon: "❤️",
    path: "/dashboard/bbps/LifeInsurance",
  },

  {
    title: "Electricity",
    icon: "⚡",
    path: "/dashboard/bbps/Electricity",
  },

  {
    title: "Loan Repayment",
    icon: "🏦",
    path: "/dashboard/bbps/LoanRepayment",
  },

  {
    title: "Municipal Tax",
    icon: "🏛️",
    path: "/dashboard/bbps/MunicipalTaxes",
  },

  {
    title: "Water",
    icon: "💧",
    path: "/dashboard/bbps/water",
  },

  {
    title: "Municipal Services",
    icon: "🧾",
    path: "/dashboard/bbps/MunicipalServices",
  },

  {
    title: "Mobile Recharge",
    icon: "📱",
    path: "/dashboard/bbps/mobileprepaid",
  },

  {
    title: "Hospital",
    icon: "🚑",
    path: "/dashboard/bbps/hospital",
  },

  {
    title: "Subscription",
    icon: "🔔",
    path: "/dashboard/bbps/subscription",
  },

  {
    title: "Credit Card",
    icon: "💳",
    path: "/dashboard/bbps/CreditCard",
  }
];

export default function BBPSHeader() {
  const [recentTransactions, setRecentTransactions] = useState([]);
  const [loadingTransactions, setLoadingTransactions] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const { mode } = useContext(ColorModeContext);


  const getRecentTransactions = async () => {
    setLoadingTransactions(true);

    const Mobilenumber = JSON.parse(sessionStorage.getItem("mobileNumber"));
    const SessionID = JSON.parse(sessionStorage.getItem("SessionID"));

    try {
      const response = await api.post(
        `${baseapi}/getbbpsrecenttransactions`,
        {
          ReqType: "TAOneApp_BBPS_RecentTransactions",
          GeoLocation: "12.9162944,77.6107175",
          MachineID: "12.9162944,77.6107175",
          EntityID: entity_id,
          Mobilenumber: Mobilenumber,
          Platform: "1",
          Statement: "BBPSTransactions",
          SessionID: SessionID,
          ApplicationType: "1",
        }
      );

      if (response.data.Response_Code === "1000") {
        setRecentTransactions(response.data.Info.Table || []);
      } else {
        setRecentTransactions([]);
      }
    } catch (err) {
      console.log(err);
      setRecentTransactions([]);
    } finally {
      setLoadingTransactions(false);
    }
  };
  useEffect(() => {
    getRecentTransactions();
  }, []);

  const [selectedTitle, setSelectedTitle] = useState("");

  const scrollRef = useRef(null);

  const navigate = useNavigate();

  const theme = useTheme();

  const isDark = theme.palette.mode === "dark";

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // SCROLL FUNCTIONS
  const scrollLeft = () => {
    scrollRef.current?.scrollBy({
      left: -250,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({
      left: 250,
      behavior: "smooth",
    });
  };

  // RENDER SERVICE
  const renderService = (service) => {
    const isSelected = selectedTitle === service.title;

    const handleNavigateAndSelect = () => {
      setSelectedTitle(service.title);

      navigate(service.path);
    };

    return (
      <Box
        key={service.title}
        onClick={handleNavigateAndSelect}
        sx={{
          position: "relative",

          minWidth: {
            xs: 95,
            sm: 110,
            md: 120,
          },

          flexShrink: 0,

          display: "flex",

          flexDirection: "column",

          alignItems: "center",

          justifyContent: "center",

          cursor: "pointer",

          py: {
            xs: 1.2,
            md: 1.8,
          },

          px: {
            xs: 1,
            md: 1.5,
          },

          borderRadius: "20px",

          transition: "all 0.3s ease",

          background: isSelected
            ? "linear-gradient(135deg,#14b8a6,#06b6d4)"
            : isDark
              ? "rgba(255,255,255,0.05)"
              : "#ffffff",

          border: isSelected
            ? "none"
            : isDark
              ? "1px solid rgba(255,255,255,0.08)"
              : "1px solid #e5e7eb",

          boxShadow: isSelected
            ? "0 10px 25px rgba(20,184,166,0.35)"
            : isDark
              ? "0 4px 12px rgba(0,0,0,0.25)"
              : "0 4px 12px rgba(0,0,0,0.06)",

          "&:hover": {
            transform: "translateY(-4px)",
          },
        }}
      >
        {/* ICON */}
        <Typography
          sx={{
            fontSize: {
              xs: 22,
              md: 28,
            },

            mb: 0.8,
          }}
        >
          {service.icon}
        </Typography>

        {/* TITLE */}
        <Typography
          sx={{
            fontWeight: 700,

            fontSize: {
              xs: 11,
              sm: 12,
              md: 13,
            },

            textAlign: "center",

            lineHeight: 1.3,

            color: isSelected
              ? "#fff"
              : isDark
                ? "#fff"
                : "#374151",
          }}
        >
          {service.title}
        </Typography>
      </Box>
    );
  };

  return (
    <>
      {/* HEADER */}
      <Box
        sx={{
          px: {
            xs: 0,
            md: 6,
          },
        }}
      >
        <DashboardHeader />
      </Box>

      {/* BODY */}
      <Box
        sx={{
          py: 3,

          background: isDark
            ? "linear-gradient(180deg,#07111f,#0f172a)"
            : "#f5f7fb",
        }}
      >
        <Box
          sx={{
            px: {
              xs: 1,
              md: 6,
            },
          }}
        >
          <AppBar
            position="static"
            elevation={0}
            sx={{
              background: isDark
                ? "rgba(255,255,255,0.06)"
                : "rgba(255,255,255,0.95)",

              backdropFilter: "blur(16px)",

              borderRadius: "28px",

              border: isDark
                ? "1px solid rgba(255,255,255,0.08)"
                : "1px solid rgba(0,0,0,0.05)",

              boxShadow: isDark
                ? "0 8px 24px rgba(0,0,0,0.35)"
                : "0 8px 24px rgba(0,0,0,0.08)",

              overflow: "hidden",
            }}
          >
            <Toolbar
              sx={{
                gap: 1,

                py: 1.2,

                px: {
                  xs: 1,
                  md: 2,
                },
              }}
            >
              {/* LEFT BUTTON */}
              <IconButton
                onClick={scrollLeft}
                sx={{
                  width: 42,
                  height: 42,

                  flexShrink: 0,

                  background: isDark
                    ? "rgba(255,255,255,0.08)"
                    : "#f3f4f6",

                  border: isDark
                    ? "1px solid rgba(255,255,255,0.08)"
                    : "1px solid #e5e7eb",

                  "&:hover": {
                    background: isDark
                      ? "rgba(255,255,255,0.15)"
                      : "#e5e7eb",
                  },
                }}
              >
                <ChevronLeftIcon
                  sx={{
                    color: isDark ? "#fff" : "#111827",
                  }}
                />
              </IconButton>

              {/* SERVICES */}
              <Box
                ref={scrollRef}
                sx={{
                  display: "flex",

                  alignItems: "center",

                  gap: {
                    xs: 1,
                    md: 2,
                  },

                  overflowX: "auto",

                  scrollBehavior: "smooth",

                  flex: 1,

                  py: 1,

                  "&::-webkit-scrollbar": {
                    display: "none",
                  },

                  scrollbarWidth: "none",
                }}
              >
                {services.map(renderService)}
              </Box>

              {/* RIGHT BUTTON */}
              <IconButton
                onClick={scrollRight}
                sx={{
                  width: 42,
                  height: 42,

                  flexShrink: 0,

                  background: isDark
                    ? "rgba(255,255,255,0.08)"
                    : "#f3f4f6",

                  border: isDark
                    ? "1px solid rgba(255,255,255,0.08)"
                    : "1px solid #e5e7eb",

                  "&:hover": {
                    background: isDark
                      ? "rgba(255,255,255,0.15)"
                      : "#e5e7eb",
                  },
                }}
              >
                <ChevronRightIcon
                  sx={{
                    color: isDark ? "#fff" : "#111827",
                  }}
                />
              </IconButton>
            </Toolbar>
          </AppBar>
        </Box>

        {/* ROUTES */}
        <Box mt={5}>
          <Outlet />
          <Card
            sx={{
              width: "95%",
              mx: "auto", // Centers the card
              borderRadius: 3,
              boxShadow: "0 6px 18px rgba(0,0,0,.08)",
              border: "1px solid #eee",
              px: 3,
            }}
          >

            <CardContent>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
              >
                <Typography
                  variant="h6"
                  fontWeight={700}
                >
                  Recent BBPS Transactions
                </Typography>

                <IconButton
                  onClick={getRecentTransactions}
                  disabled={loadingTransactions}
                >
                  <RefreshIcon />
                </IconButton>
              </Box>

              {loadingTransactions ? (
                <Box py={6} textAlign="center">
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <TableContainer
                    component={Paper}
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: "1px solid #e5e7eb",
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow
                          sx={{
                            bgcolor: "#16a34a",
                          }}
                        >
                          <TableCell sx={{ color: "#fff", fontWeight: 700 }}>
                            Logo
                          </TableCell>

                          <TableCell sx={{ color: "#fff", fontWeight: 700 }}>
                            Service
                          </TableCell>

                          <TableCell sx={{ color: "#fff", fontWeight: 700 }}>
                            Customer ID
                          </TableCell>

                          <TableCell sx={{ color: "#fff", fontWeight: 700 }}>
                            Amount
                          </TableCell>

                          <TableCell sx={{ color: "#fff", fontWeight: 700 }}>
                            Date
                          </TableCell>

                          <TableCell sx={{ color: "#fff", fontWeight: 700 }}>
                            Type
                          </TableCell>

                          <TableCell sx={{ color: "#fff", fontWeight: 700 }}>
                            Description
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {recentTransactions.length > 0 ? (
                          recentTransactions
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((item, index) => (
                              <TableRow
                                key={index}
                                hover
                              >
                                <TableCell>
                                  <Avatar
                                    src={item.BillerLogo}
                                    variant="rounded"
                                    sx={{
                                      width: 45,
                                      height: 45,
                                    }}
                                  />
                                </TableCell>

                                <TableCell>
                                  {item.ServiceName}
                                </TableCell>

                                <TableCell>
                                  {item.CustomerID}
                                </TableCell>

                                <TableCell
                                  sx={{
                                    fontWeight: 700,
                                    color: "#16a34a",
                                  }}
                                >
                                  ₹{item.Amount}
                                </TableCell>

                                <TableCell>
                                  {new Date(
                                    item.TransactionDate
                                  ).toLocaleDateString()}
                                </TableCell>

                                <TableCell>
                                  <Chip
                                    label={item.TransactionType}
                                    color="success"
                                    size="small"
                                  />
                                </TableCell>

                                <TableCell
                                  sx={{
                                    maxWidth: 350,
                                  }}
                                >
                                  {item.Description}
                                </TableCell>
                              </TableRow>
                            ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={7}
                              align="center"
                            >
                              No Transactions Found
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    component="div"
                    count={recentTransactions.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[5]}
                    sx={{
                      "& .MuiTablePagination-toolbar": {
                        minHeight: 56,
                      },
                    }}
                  />
                </>
              )}
            </CardContent>
          </Card>
        </Box>
      </Box>
    </>
  );
}